import { Component, For, Show } from 'solid-js';
import { useProfileTranslations } from '../data/profile-translations';
import { useLanguage } from '../i18n/LanguageContext';

const Projects: Component = () => {
  const { language, t } = useLanguage();
  const profileData = () => useProfileTranslations(language());

  return (
    <section class="projects" id="projects">
      <div class="container">
        <h2 class="section-title">{t('projects.title')}</h2>
        <div class="projects-grid">
          <For each={profileData().projects}>
            {(project) => (
              <div class="project-card">
                <Show when={project.image}>
                  <img src={project.image} alt={project.name} class="project-image" />
                </Show>
                <h3 class="project-name">{project.name}</h3>
                <p class="project-description">{project.description}</p>
                <div class="project-technologies">
                  <For each={project.technologies}>
                    {(tech) => <span class="tech-tag">{tech}</span>}
                  </For>
                </div>
                <div class="project-stats">
                  <Show when={project.stars !== undefined}>
                    <span class="project-stat">
                      <svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor">
                        <path d="M8 .25a.75.75 0 01.673.418l1.882 3.815 4.21.612a.75.75 0 01.416 1.279l-3.046 2.97.719 4.192a.75.75 0 01-1.088.791L8 12.347l-3.766 1.98a.75.75 0 01-1.088-.79l.72-4.194L.818 6.374a.75.75 0 01.416-1.28l4.21-.611L7.327.668A.75.75 0 018 .25z"/>
                      </svg>
                      {project.stars}
                    </span>
                  </Show>
                  <Show when={project.forks !== undefined}>
                    <span class="project-stat">
                      <svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor">
                        <path d="M5 3.25a.75.75 0 11-1.5 0 .75.75 0 011.5 0zm0 2.122a2.25 2.25 0 10-1.5 0v.878A2.25 2.25 0 005.75 8.5h1.5v2.128a2.251 2.251 0 101.5 0V8.5h1.5a2.25 2.25 0 002.25-2.25v-.878a2.25 2.25 0 10-1.5 0v.878a.75.75 0 01-.75.75h-4.5A.75.75 0 015 6.25v-.878zm3.75 7.378a.75.75 0 11-1.5 0 .75.75 0 011.5 0zm3-8.75a.75.75 0 100-1.5.75.75 0 000 1.5z"/>
                      </svg>
                      {project.forks}
                    </span>
                  </Show>
                </div>
                <div class="project-links">
                  <Show when={project.github}>
                    <a href={project.github} target="_blank" rel="noopener noreferrer" class="project-link">
                      GitHub
                      <svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor">
                        <path d="M3.75 2a.75.75 0 000 1.5h7.69L2.22 12.72a.75.75 0 101.06 1.06L12.5 4.56v7.69a.75.75 0 001.5 0v-9.5a.75.75 0 00-.75-.75h-9.5z"/>
                      </svg>
                    </a>
                  </Show>
                  <Show when={project.website}>
                    <a href={project.website} target="_blank" rel="noopener noreferrer" class="project-link">
                      Website
                      <svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor">
                        <path d="M3.75 2a.75.75 0 000 1.5h7.69L2.22 12.72a.75.75 0 101.06 1.06L12.5 4.56v7.69a.75.75 0 001.5 0v-9.5a.75.75 0 00-.75-.75h-9.5z"/>
                      </svg>
                    </a>
                  </Show>
                </div>
              </div>
            )}
          </For>
        </div>
      </div>
    </section>
  );
};

export default Projects;
